const o = {
  color: {
    icon: "#abb9c7ff"
  }
};
export {
  o as loadingDots
};
